/*
 * Styled dropdown for select.custom-select (collection sort).
 * Vanilla replacement for the previous jQuery implementation; re-initializes
 * after facet filtering re-renders the sort control via AJAX.
 */
(function () {
  function buildCustomSelect(select) {
    if (select.dataset.customSelectInit) return;
    select.dataset.customSelectInit = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    var shell = document.createElement('div');
    shell.className = select.className.replace(/\bselect__select\b/, '').trim();
    var selectedOption = select.selectedOptions && select.selectedOptions[0];
    var initialLabel = (selectedOption && selectedOption.text.trim()) || select.getAttribute('placeholder') || '';
    var html = '<span class="custom-select-trigger">' + initialLabel + '</span>';
    html += '<div class="custom-options">';
    select.querySelectorAll('option').forEach(function (opt) {
      html += '<span class="custom-option ' + (opt.className || '') + '" data-value="' + opt.value + '">' + opt.innerHTML + '</span>';
    });
    html += '</div>';
    shell.innerHTML = html;
    select.style.display = 'none';
    wrapper.appendChild(shell);

    /* Only one list open at a time (Jenny 2026-09-29: with two options, both
       lists could be open and stacked into what looked like one). The
       trigger used to stop its click from reaching the page, which also
       stopped the OTHER list's close-on-outside-click from ever hearing it.
       Now opening one closes the rest, and one page-wide listener below
       closes them all on a click anywhere else. */
    var trigger = shell.querySelector('.custom-select-trigger');
    trigger.addEventListener('click', function () {
      var wasOpen = shell.classList.contains('opened');
      closeAll();
      if (!wasOpen) {
        shell.classList.add('opened');
        document.dispatchEvent(new CustomEvent('fj:dropdown-open', { detail: shell }));
      }
    });

    var firstOption = shell.querySelector('.custom-option:first-of-type');
    if (firstOption) {
      firstOption.addEventListener('mouseenter', function () { firstOption.parentElement.classList.add('option-hover'); });
      firstOption.addEventListener('mouseleave', function () { firstOption.parentElement.classList.remove('option-hover'); });
    }

    if (selectedOption) {
      var initialMatch = shell.querySelector('.custom-option[data-value="' + CSS.escape(selectedOption.value) + '"]');
      if (initialMatch) initialMatch.classList.add('selection');
    }

    shell.querySelectorAll('.custom-option').forEach(function (optionEl) {
      optionEl.addEventListener('click', function () {
        select.value = optionEl.dataset.value;
        shell.querySelectorAll('.custom-option').forEach(function (o) { o.classList.remove('selection'); });
        optionEl.classList.add('selection');
        shell.classList.remove('opened');
        trigger.textContent = optionEl.textContent;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var current = new URLSearchParams(location.search).get('sort_by');
    if (current) {
      var match = shell.querySelector('.custom-option[data-value="' + CSS.escape(current) + '"]');
      if (match) {
        match.classList.add('selection');
        trigger.textContent = match.textContent;
      }
    }
  }

  function closeAll() {
    document.querySelectorAll('.custom-select.opened').forEach(function (el) {
      el.classList.remove('opened');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.custom-select')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Only one dropdown open on the whole page (Jenny 2026-09-29). Every
     dropdown (these custom selects, the reviews filter and the reviews
     sort) announces 'fj:dropdown-open' when it opens and closes
     itself when it hears another one's. A shared signal, because each
     script's own close-on-outside-click can be skipped: the filter button
     swallows its click before the page sees it, which left the sort list
     open underneath the filter list. */
  document.addEventListener('fj:dropdown-open', function (e) {
    document.querySelectorAll('.custom-select.opened').forEach(function (el) {
      if (el !== e.detail) el.classList.remove('opened');
    });
  });

  function initAll(root) {
    (root || document).querySelectorAll('select.custom-select').forEach(buildCustomSelect);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    var facets = document.getElementById('main-collection-filters');
    if (facets && 'MutationObserver' in window) {
      new MutationObserver(function () { initAll(facets); }).observe(facets, { childList: true, subtree: true });
    }
  });
})();
